/* src/app/features/irregularidade_empresa/pesquisa/listagem/irregularidade_empresa.listagem.component.scss */
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=irregularidade_empresa.listagem.component.css.map */
